import React from 'react';
import { FaInstagram, FaFacebook, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import './App.css';

import ScheduleTable from './ScheduleTable';
import AdminPanel from './AdminPanel';
import logoFinal from './assets/logo-final.png';
import { db } from './firebase';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';

const facts = [
    {
        id: 1,
        title: "Your baby has more bones than you.",
        text: "At birth, your baby has about 300 bones. You have 206 bones. How is that possible? In fact, some of your little one’s bones are still growing together.. Your baby’s bones are therefore not yet fully developed at birth. For example: you’ve probably already heard of the fontanelle. Your baby’s skull is initially made up of several plates, which then grow together by the time they are 1 ½ years old."
    },
    {
        id: 2,
        title: "Babies have a particularly developed brain.",
        text: "Babies are born with a brain that already has 100 billion nerve cells. possesses. These nerve cells are interconnected and enable your little one to process information and learn."
    },
    {
        id: 3,
        title: "Babies can breathe and swallow at the same time.",
        text: "After birth, your baby's larynx is positioned higher; it lowers within the first three months of life. This allows your little one to to breathe and swallow at the same time. While you are breastfeeding your baby or giving them the bottle, they can continue to breathe and swallow at the same time thanks to their higher-positioned larynx."
    },
    {
        id: 4,
        title: "Babies have a high number of taste buds.",
        text: "Your baby has more taste buds on their tongue than you do. This enables him to perceive different flavours more intensely. However, his brain is not yet able to distinguish between the various tastes. For now, there is really only one taste that matters: the taste of breast milk or formula."
    },
    {
        id: 5,
        title: "Babies are as loud as a pneumatic drill.",
        text: "Is hunger coming? Is the nappy full? Is tiredness setting in? Babies can only express that something is wrong by crying. And The cries of your little bundle of joy can reach a volume of up to 120 decibels. That is equivalent to the pounding of a pneumatic drill. At work, your boss would have to provide you with hearing protection at that level of noise (by law, from 85 decibels)."
    },
    {
        id: 6,
        title: "Babies cry at first without tears.",
        text: "Your baby's tear ducts are not yet fully developed after birth. Only after about a month do the first tears begin to flow.Until then, they cry without any tears at all. Sometimes, however, the tear ducts are still a little too narrow even after the first month, which means they can become blocked in some babies. If your little one’s eyes are frequently stuck together, your midwife, paediatrician or doctor can help you."
    },
    {
        id: 7,
        title: "Every baby is different.",
        text: "On average, babies are born weighing between 3,300 and 3,500 grams. However, many babies are born significantly lighter or heavier. The lightest baby in the world.came into the world in Singapore in 2021 via emergency caesarean section. The little girl weighed only 212 grams. was born almost four months prematurely. According to the Guinness Book of Records, weighed the largest baby ever born and survived, 10.2 kilograms. The boy was born in 1955 in Aversa, near Naples in Italy."
    },
    {
        id: 8,
        title: "Nappies, nappies, nappies.",
        text: "Your baby will need around 5,500 nappies before they start using the potty at the age of 2½.. Some children discover the potty earlier and others later. So don’t worry if your little one only starts using the toilet at the age of three. Every child has their own pace."
    }
];

function App() {
    const [showCookies, setShowCookies] = React.useState(false);
    const [modalContent, setModalContent] = React.useState(null);
    const [isScrolled, setIsScrolled] = React.useState(false);
    const [activeCard, setActiveCard] = React.useState(null);
    const [activeFact, setActiveFact] = React.useState(null);

    React.useEffect(() => {
        const handleClickOutside = (e) => {
            // Close active card if click is outside of an experience-item
            if (!e.target.closest('.experience-item') && !e.target.closest('.mobile-close-btn')) {
                setActiveCard(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside, { passive: true });
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);

    React.useEffect(() => {
        const cookiesAccepted = localStorage.getItem("cookiesAccepted");
        if (!cookiesAccepted) {
            setShowCookies(true);
        }

        const handleScroll = () => {
            if (window.scrollY > 300) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setShowCookies(false);
    };

    if (window.location.pathname === '/admin') {
        return <AdminPanel />;
    }

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="App">
            {isScrolled && (
                <a href="#booking" className="sticky-cta">
                    Join 8-Week Journey
                </a>
            )}
            <a href="https://wa.me/31642516119" target="_blank" rel="noopener noreferrer" className="floating-whatsapp" aria-label="Chat with Anne on WhatsApp">
                <FaWhatsapp style={{ fontSize: '32px' }} />
            </a>
            <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} id="top">
                <a href="#top" className="nav-mini-logo" onClick={scrollToTop}>
                    <img src={logoFinal} alt="Blossom & Bond Mini Logo" />
                </a>
                <div className="nav-links">
                    <a href="#story">Our Story</a>
                    <a href="#clases-section">Classes</a>
                    <a href="#booking" className="nav-book-btn">Book Now</a>
                    <a href="https://wa.me/31642516119" target="_blank" rel="noopener noreferrer">Contact</a>
                </div>
            </nav>

            <header className="hero">
                <div className="hero-container">
                    <div className="hero-content">
                        <div className="hero-branding">
                            <img
                                src="/B&B logo-vertical.png"
                                alt="Blossom & Bond Logo"
                                className="hero-logo"
                            />
                            <h1>Nurturing connection<br/>from the<br/>very beginning</h1>
                        </div>
                        <p>Playful, interactive classes that support your child's development and build a strong parent - child bond</p>
                        <a href="#booking" className="btn-primary">Join the 8-Week Journey</a>
                    </div>
                    <div className="hero-image-placeholder">
                        <img
                            src="/hero nueva.jpg"
                            alt="Mother and baby connection"
                            className="image-vertical-soft"
                        />
                    </div>
                </div>
            </header>

            <section id="clases-section" className="experience-section">
                <div 
                    className="experience-item" 
                    onClick={(e) => { if(!e.target.closest('button')) setActiveCard(activeCard === 1 ? null : 1); }} 
                    onMouseEnter={() => setActiveCard(1)} 
                    onMouseLeave={() => setActiveCard(null)}
                >
                    <div className="circle-image-container">
                        <img src="/circulo 1.png?v=2" alt="Natural wooden toys" className="experience-circle-img pos-c1" />
                        <div className="plus-icon">+</div>
                        <div className={`floating-info-card ${activeCard === 1 ? 'active' : ''}`}>
                            <button className="mobile-close-btn" onClick={(e) => { e.stopPropagation(); setActiveCard(null); }}>✕</button>
                            Baby Blossoms provides a peaceful experience for babies 0–6 months, encouraging early development while strengthening the connection between parent/caregiver and child.
                        </div>
                    </div>
                    <h3>Baby Blossoms</h3>
                    <p>0–6 months: Bonding & Discovery</p>
                </div>
                <div 
                    className="experience-item" 
                    onClick={(e) => { if(!e.target.closest('button')) setActiveCard(activeCard === 2 ? null : 2); }} 
                    onMouseEnter={() => setActiveCard(2)} 
                    onMouseLeave={() => setActiveCard(null)}
                >
                    <div className="circle-image-container">
                        <img src="/circulo 2.png?v=2" alt="Hands contact and tenderness" className="experience-circle-img pos-c2" />
                        <div className="plus-icon">+</div>
                        <div className={`floating-info-card ${activeCard === 2 ? 'active' : ''}`}>
                            <button className="mobile-close-btn" onClick={(e) => { e.stopPropagation(); setActiveCard(null); }}>✕</button>
                            Mini Adventurers is a playful class for babies 6–12 months who are on the move and ready to explore, supporting their growing confidence while you share special moments together.
                        </div>
                    </div>
                    <h3>Mini Adventurers</h3>
                    <p>6–12 months: Play & Explore</p>
                </div>
                <div 
                    className="experience-item" 
                    onClick={(e) => { if(!e.target.closest('button')) setActiveCard(activeCard === 3 ? null : 3); }} 
                    onMouseEnter={() => setActiveCard(3)} 
                    onMouseLeave={() => setActiveCard(null)}
                >
                    <div className="circle-image-container">
                        <img src="/circulo 3.png?v=4" alt="Toddler exploring" className="experience-circle-img pos-c3" />
                        <div className="plus-icon">+</div>
                        <div className={`floating-info-card ${activeCard === 3 ? 'active' : ''}`}>
                            <button className="mobile-close-btn" onClick={(e) => { e.stopPropagation(); setActiveCard(null); }}>✕</button>
                            A playful, nurturing group for toddlers aged 1–3 years, where curiosity leads the way. Through movement, music, and simple activities, children develop confidence and coordination while discovering the world around them.
                        </div>
                    </div>
                    <h3>Little Explorers</h3>
                    <p>1–3 years: Curiosity & Confidence</p>
                </div>
            </section>

            <section className="wonder-strip">
                <div className="wonder-container">
                    <h3>A little touch of wonder...</h3>
                    <div className="facts-grid-interactive">
                        {facts.map((fact) => (
                            <div 
                                key={fact.id} 
                                className="fact-card-mini"
                                onClick={() => setActiveFact(fact)}
                            >
                                <div className="fact-number">{fact.id}.</div>
                                <strong>{fact.title}</strong>
                                <div className="fact-plus-icon">+</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section id="story" className="our-story">
                <div className="our-story-container">
                    <h2>The Heart Behind Blossom & Bond</h2>
                    <div className="our-story-body">
                        Blossom & Bond was born from a simple yet powerful idea: that the earliest years of life shape the deepest connections.

                        As a mother, I experienced both the beauty and the uncertainty of early motherhood. Is my child developing as they should? Am I doing enough? Blossom & Bond was created to gently remove that pressure.

                        Inspired by the natural process of growth, like a flower slowly blossoming, we believe that children thrive in environments filled with calm, intention, and connection.
                    </div>
                    <p className="our-story-closing">
                        'Every child blossoms at their own rhythm.'
                    </p>
                    <img src="/The heart behind B&B.jpg" alt="Natural sensory materials" className="story-image-placeholder" />
                </div>
            </section>

            <section id="journey" className="journey-section">
                <h2 style={{ textAlign: 'center', marginBottom: '60px' }}>A Journey for the Senses</h2>
                <div className="journey-container">
                    <div className="journey-step">
                        <h3>Step 1: Arrival</h3>
                        <p>We settle into our calm, prepared environment</p>
                    </div>
                    <div className="journey-step">
                        <h3>Step 2: Explore</h3>
                        <p>Babies and caregivers will embark on a journey filled with adventure and discovery</p>
                    </div>
                    <div className="journey-step">
                        <h3>Step 3: Connect</h3>
                        <p>A gentle closing circle to reinforce the bond</p>
                    </div>
                </div>
            </section>

            <section className="philosophy-section">
                <img
                    src="/space 2.png"
                    alt="Baby Sensory Environment"
                    className="philosophy-image"
                />
                <div className="philosophy-content">
                    <h2>Ready to begin this journey? Join us in a space where there is no rush, only connection, where every detail is cared for to provide a clean, safe, and comforting environment.</h2>
                </div>
            </section>

            <section id="testimonials" className="testimonials-section">
                <h2>Voices of our Community</h2>
                <div className="testimonials-container">
                    <div className="testimonial-card">
                        <p className="testimonial-quote">"A sanctuary of peace for me and my baby. We felt so held and seen from the first moment."</p>
                        <p className="testimonial-author">— Elena & Baby Mia</p>
                    </div>
                    <div className="testimonial-card">
                        <p className="testimonial-quote">"The sensory materials are beautiful, and the atmosphere is so calming. Finally, a place where there is no rush."</p>
                        <p className="testimonial-author">— Sarah & Baby Noah</p>
                    </div>
                    <div className="testimonial-card">
                        <p className="testimonial-quote">"The connection I’ve built with other mothers here is as precious as the connection with my child."</p>
                        <p className="testimonial-author">— Clara & Baby Oliver</p>
                    </div>
                </div>
            </section>

            <section id="offerings" className="offerings-section">
                <h2>Our Program</h2>
                <div className="offerings-container">
                    <div className="offering-cards" style={{ justifyContent: 'center' }}>
                        <div className="offering-card" style={{ maxWidth: '650px', width: '100%' }}>
                            <h3>8-Week Journey</h3>
                            <p>8 sessions in total, held once a week. Each session is designed to build deep connection. Includes expert guidance, thoughtfully designed activities and a supportive community of parents at Blossom & Bond (€ 145).</p>
                        </div>
                    </div>
                    <div className="logistics-block">
                        <p><strong>Duration & Capacity:</strong> Each session lasts 60 minutes. Limited to 7 spots per group to ensure an intimate and calm environment.</p>
                        <p style={{ marginTop: '15px' }}><strong>Flexible scheduling:</strong> Choose between Tuesday or Wednesday for your weekly session, according to your baby’s age group.</p>
                    </div>
                </div>
            </section>

            <div id="booking" className="schedule-section-header" style={{ textAlign: 'center', padding: '80px 20px 20px' }}>
                <h2 style={{ marginBottom: '15px', lineHeight: '1.3' }}>
                    Join the 8-Week Journey<br />Reserve Your Spot
                </h2>
                <p style={{ 
                    fontFamily: "'Lato', sans-serif", 
                    fontSize: '16px', 
                    color: '#666', 
                    maxWidth: '800px', 
                    margin: '0 auto', 
                    lineHeight: '1.6',
                    opacity: 0.8
                }}>
                    Nurture your connection week by week in our calm sanctuary. Select your preferred day and age group below to join the upcoming 8-week cycle.
                </p>
            </div>

            <ScheduleTable />


            <section id="contact" className="contact-section">
                <iframe
                    title="Blossom & Bond Location"
                    className="contact-map-iframe"
                    src="https://maps.google.com/maps?q=Koninginnegracht%20101,%20The%20Hague,%20Netherlands%202514%20AL&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <div className="contact-info">
                    <h2>Get in Touch</h2>
                    <div className="contact-details">
                        <p>
                            <a
                                href="https://www.google.com/maps/search/?api=1&query=Koninginnegracht+101,+The+Hague,+Netherlands+2514+AL"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: 'inherit', textDecoration: 'none' }}
                            >
                                📍 Location: koninginnegracht 101, The Hague, Netherlands 2514 AL
                            </a>
                        </p>
                        <p>✉️ Email: blossomnbond@gmail.com</p>
                    </div>
                    <a href="https://wa.me/31642516119" target="_blank" rel="noopener noreferrer" className="btn-primary btn-cream" style={{ width: 'auto', display: 'inline-flex', alignItems: 'center' }}>
                        <FaWhatsapp style={{ marginRight: '8px', fontSize: '20px' }} /> WhatsApp Chat
                    </a>
                </div>
            </section>

            <footer className="footer-professional">
                <div className="footer-content">
                    <img src="/B&B logo-horizontal.png" alt="Blossom & Bond Celeste Logo" className="footer-logo-small" />
                    <div className="footer-links">
                        <a href="#">Home</a>
                        <a href="#story">Story</a>
                        <a href="#clases-section">Classes</a>
                    </div>
                    <p className="footer-tagline">Nurturing little wonders since 2024</p>
                    <div className="footer-legal-links" style={{ display: 'flex', gap: '20px', marginBottom: '30px', fontSize: '14px' }}>
                        <a href="#" onClick={(e) => { e.preventDefault(); setModalContent('privacy'); }} style={{ color: 'var(--primary-blue)', textDecoration: 'underline' }}>Privacy Policy</a>
                        <a href="#" onClick={(e) => { e.preventDefault(); setModalContent('terms'); }} style={{ color: 'var(--primary-blue)', textDecoration: 'underline' }}>Terms & Conditions</a>
                    </div>
                    <div className="footer-socials">
                        <a href="https://www.instagram.com/blossomandbond.thehague/" target="_blank" rel="noopener noreferrer">
                            <FaInstagram />
                        </a>
                        <a href="https://www.facebook.com/blossomandbond.thehague/" target="_blank" rel="noopener noreferrer">
                            <FaFacebook />
                        </a>
                    </div>
                    <p className="footer-copyright">
                        © 2026 Blossom & Bond. Baby Sensory & Connection Classes • The Hague
                    </p>
                </div>
            </footer>
            {/* --- RGPD COMPLIANCE UI --- */}
            {/* Cookie Banner */}
            {showCookies && (
                <div className="cookie-banner">
                    <p>We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.</p>
                    <button onClick={acceptCookies} className="btn-primary cookie-btn">Accept</button>
                </div>
            )}

            {/* General Modal */}
            {modalContent && (
                <div className="modal-overlay" onClick={() => setModalContent(null)}>
                    <div className={`modal-content ${modalContent === 'facts' ? 'modal-content-wide' : ''}`} onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal" onClick={() => setModalContent(null)}>✕</button>
                        {modalContent === 'privacy' ? (
                            <PrivacyPolicy />
                        ) : (
                            <TermsAndConditions />
                        )}
                    </div>
                </div>
            )}

            {/* Facts Interactive Modal */}
            {activeFact && (
                <div className="modal-overlay" onClick={() => setActiveFact(null)}>
                    <div className="modal-content fact-popup-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal mobile-close-btn-fixed" onClick={() => setActiveFact(null)}>✕</button>
                        <h2 style={{ color: 'var(--primary-blue)', marginBottom: '20px' }}>{activeFact.id}. {activeFact.title}</h2>
                        <p style={{ fontSize: '18px', lineHeight: '1.7', color: 'var(--text-color)' }}>{activeFact.text}</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default App;